__webpack_require__.p = "/react-typescript-app/";